//
//
//
//
//
//
//
//
export default {
  name: 'SkText',
  props: {
    text: {}
  }
};